var _path, _circle, _circle2, _path2, _path3, _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEmptyMyPartsWidgetIcon = function SvgEmptyMyPartsWidgetIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 130,
    viewBox: "0 0 104 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 44.5h23l17 54h46L102 62H47M34 79.5h60.5",
    stroke: "#2C112D",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 46,
    cy: 121,
    r: 8,
    stroke: "#2C112D",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 78,
    cy: 121,
    r: 8,
    stroke: "#2C112D",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63 0c14.36 0 26 11.64 26 26 0 13.687-10.575 24.903-24 25.924v-2.008C77.319 48.9 87 38.581 87 26 87 12.745 76.255 2 63 2S39 12.745 39 26h-2C37 11.64 48.64 0 63 0Z",
    fill: "#2C112D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.15 17.447a1 1 0 0 1 0 1.414l-9.192 9.193a1.008 1.008 0 0 1-.898.274.996.996 0 0 1-.516-.274l-9.192-9.193a1 1 0 1 1 1.414-1.414l8.485 8.486 8.485-8.486a1 1 0 0 1 1.414 0Z",
    fill: "#2C112D"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 10,
    width: 2,
    height: 17,
    rx: 1,
    fill: "#2C112D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 62,
    y: 26.724,
    width: 2,
    height: 20,
    rx: 1,
    transform: "rotate(-65.228 62 26.724)",
    fill: "#2C112D"
  })));
};
export default SvgEmptyMyPartsWidgetIcon;